import React, { Component } from "react";
import AppContext from "../../../contexts/AppContext";

export class Progress extends Component {
	
	constructor(props) {
        super(props);        
    }
	
	render() {
		
		return (
            <div className="progress my mb-3">
              <div className="progress-bar" role="progressbar" style={{ width: this.props.width }} aria-valuenow={this.props.ariavalue} aria-valuemin="0" aria-valuemax="100">{this.props.content}</div>
            </div>
		);
        
    }
}

Progress.contextType = AppContext;
export default Progress;



// WEBPACK FOOTER //
// ./src/components/general/include/Progress.js